import { TERMS_OF_SERVICE_AND_PRIVACY_POLICY_URL } from "@shared/utils/constants";
import { ThemeProvider } from "@shared/providers/ThemeProvider";
import { useAppLogoAsset } from "@shared/hooks/useAppLogoAsset";
import { useSupportDialog } from "@shared/hooks/useSupportDialog";
import { SupportConfirmDialog } from "@shared/components/SupportConfirmDialog";
import {
  Address,
  BrandBlock,
  BrandLogo,
  Column,
  ColumnLink,
  ColumnsWrapper,
  ColumnTitle,
  Copyright,
  Divider,
  FooterContainer,
  LeftColumn,
  LeftColumnInner,
  LinkButton,
  RightColumn,
  Row,
  Tagline,
} from "./RadarMarketingFooter.styles";

export const RadarMarketingFooter = () => {
  const year = new Date().getFullYear();
  const supportDialog = useSupportDialog();
  const {
    src: logoSrc,
    alt: logoAlt,
    height: logoHeight,
  } = useAppLogoAsset("white");

  return (
    <>
      <ThemeProvider defaultTheme="dark">
        <FooterContainer>
          <Row>
            <LeftColumn>
              <LeftColumnInner>
                <BrandBlock>
                  <BrandLogo
                    src={logoSrc}
                    alt={logoAlt}
                    style={{ height: logoHeight }}
                  />
                  <Tagline variant="body1">
                    Public-signal monitoring for relationship-driven
                    professionals.
                  </Tagline>
                </BrandBlock>
              </LeftColumnInner>
            </LeftColumn>

            <RightColumn>
              <ColumnsWrapper>
                <Column>
                  <ColumnTitle variant="overline">Company</ColumnTitle>
                  <Address variant="body2">2913 Fillmore Street</Address>
                  <Address variant="body2">San Francisco, CA 94115</Address>
                </Column>

                <Column>
                  <ColumnTitle variant="overline">Resources</ColumnTitle>
                  <ColumnLink
                    href={TERMS_OF_SERVICE_AND_PRIVACY_POLICY_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Legal and Privacy
                  </ColumnLink>
                  <LinkButton type="button" onClick={supportDialog.open}>
                    Support
                  </LinkButton>
                </Column>
              </ColumnsWrapper>
            </RightColumn>
          </Row>

          <Divider />

          <Copyright variant="body2">
            © {year} Radar by Sidekick. All rights reserved.
          </Copyright>
        </FooterContainer>
      </ThemeProvider>

      <SupportConfirmDialog
        open={supportDialog.isOpen}
        onClose={supportDialog.close}
      />
    </>
  );
};
